import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c61652c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }

import { ref, PropType, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';

import { Consultation } from '@/interfaces/Consultation';
import { DateUtils } from '@/utils/DateUtils';
import type { Doctor } from '@/interfaces/Doctor';
import DoctorService from '@/services/DoctorService';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientConsultationList',
  props: {
  consultations: {
    type: Array as PropType<Consultation[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const route = useRoute();
const doctorId = route.params.id as string;
const doctor = ref<Doctor | null>(null);

const sortedConsultations = computed(() => {
  return [...props.consultations].sort((a, b) => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
});

const safe = (v: any) => (v != null ? v + ' RON' : '0 RON');
const safeDisplay = (value: string): string => value || '';

onMounted(async () => {
  if (doctorId) {
    doctor.value = await DoctorService.fetchDoctor(doctorId);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: sortedConsultations.value,
      stripedRows: "",
      paginator: "",
      rows: 10,
      rowsPerPageOptions: [10, 20, 50]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "Nume Medic" }, {
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(safeDisplay(doctor.value?.title!) +
              ' ' +
              safeDisplay(doctor.value?.firstName!) +
              ' ' +
              safeDisplay(doctor.value?.lastName!)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Data consultatie",
          field: "startDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.startDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Valoare consultatie",
          field: "value",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Tag), {
              value: safe(data.value).toString(),
              severity: "info"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Factura" }, {
          body: _withCtx(({ data }) => [
            (data.invoiceUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: data.invoiceUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "text-blue-600 underline"
                }, " Descarcă PDF ", 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})